<template>
    <div class="hs-select">
        <label v-if="label" :for="resolvedId" class="hs-select__label">
            {{ label }}
        </label>
        <div class="hs-select__wrap" :class="{ 'hs-select__wrap--disabled': disabled }">
            <div role="status" class="animate-pulse" v-if="isLoading">
                <div class="hs-select__skeleton"></div>
            </div>
            <div v-else class="hs-select__control" :class="customClass">
                <select :id="resolvedId" class="hs-select__field" :multiple="multiple" :disabled="disabled"
                    :required="required" :value="selectedValue" :name="name" :searchable="searchable"
                    :clearable="clearable" v-model="selectedValue">
                    <option selected disabled>
                        {{ placeholder }}
                    </option>
                    <option v-for="option in options" :key="option.value" :value="option.value">
                        {{ option.name }}
                    </option>
                </select>
                <vue-feather type="chevron-down" size="16" class="hs-select__icon" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "HSSelect",
    props: {
        options: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: "Select option",
        },
        name: String,
        selected: String,
        id: String,
        label: String,
        error: String,
        disabled: Boolean,
        required: Boolean,
        multiple: Boolean,
        searchable: Boolean,
        clearable: Boolean,
        customClass: String,
        isLoading: {
            type: Boolean,
            default: false,
        },
        value: [String, Array, Number],
    },
    computed: {
        resolvedId() {
            return this.id || this.name || "hs-select";
        },
        selectedValue: {
            get() {
                return (
                    this.value ||
                    (this.options.length > 0 ? this.options[0].value : "") ||
                    ""
                );
            },
            set(newValue) {
                this.$emit("value-change", newValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.hs-select__label {
    display: block;
    margin-bottom: 0.5rem;
    padding-inline: 0.25rem;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--hs-muted);
}

.hs-select__control {
    position: relative;
}

.hs-select__field {
    width: 100%;
    min-height: 54px;
    appearance: none;
    border-radius: 18px;
    border: 1px solid var(--hs-border);
    padding: 0.85rem 2.75rem 0.85rem 1rem;
    font-size: 0.92rem;
    color: var(--hs-text);
    background: color-mix(in srgb, var(--hs-surface) 90%, transparent);
    outline: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.hs-select__field:focus {
    border-color: color-mix(in srgb, var(--hs-primary) 48%, transparent);
    box-shadow: 0 0 0 4px color-mix(in srgb, var(--hs-primary) 12%, transparent);
}

.hs-select__icon {
    position: absolute;
    top: 50%;
    right: 1rem;
    transform: translateY(-50%);
    pointer-events: none;
    color: var(--hs-muted);
}

.hs-select__wrap--disabled .hs-select__field {
    opacity: 0.65;
    cursor: not-allowed;
}

.hs-select__skeleton {
    height: 54px;
    width: 100%;
    border-radius: 18px;
    background: color-mix(in srgb, var(--hs-bg-soft) 80%, transparent);
}
</style>
